import React from "react";

function ConfirmationPopup({
    setOpenConfirmPopup,
    handleSubmitAdaptive,
    autoEvaluated,
    adaptive,
    handleAutoEvaluatedSubmit,
    handleSubmit,
    nextButtonDisabled,
    unAttemptedTitles,
    setUnAnsweredPopup
}) {

    const handleIndividualAssessment = () => {
        if (unAttemptedTitles.length > 0) {
            setUnAnsweredPopup(true);
            return;
        }
        if (!adaptive && !autoEvaluated) {
            handleSubmit();
        } else if (autoEvaluated) {
            handleAutoEvaluatedSubmit();
        } else if (adaptive) {
            handleSubmitAdaptive();
        }
        setOpenConfirmPopup(false)
    };
    return (
        <div className="ContainerSubmitedSucess modal fade show d-block" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <img className="prereadLoader" src="/images/alert.svg" alt="icon" style={{ width: "60px", height: "60px", margin: "auto" }} /> */}
                    </div>
                    <div className="modal-body" style={{ textAlign: "center", fontSize: "19px", fontWeight: "500" }}>
                        {'Are you sure you want to submit? '}
                    </div>
                    <hr style={{ margin: "15px 0px" }} />
                    <div className="flex gap-5 justify-center items-center p-2">
                        <button type="button" className="nobtnclose" onClick={() => {
                            setOpenConfirmPopup(false)
                        }}>No</button>
                        <button type="button" disabled={nextButtonDisabled} className="okayBtnsucess" onClick={() => {
                            handleIndividualAssessment()
                        }}>Yes</button>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmationPopup;
